exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-workshops table tr:first-of-type th {\n  border-top: none;\n}\n.list-workshops table tr > td > button {\n  color: inherit;\n  text-decoration: underline;\n}\n", ""]);

// exports
